import React from 'react';
import { STATS, INGREDIENT_PILLARS, IMG } from '../mock';
import { Leaf } from 'lucide-react';

export default function InfoStrip() {
  return (
    <>
      <section className="max-w-7xl mx-auto px-4 sm:px-6 pt-14 sm:pt-20">
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-3 sm:gap-4">
          {STATS.map((s) => (
            <div key={s.label} className="bg-[#FBF8EF] rounded-2xl border border-[#D6CFB8] p-5 sm:p-6 hover:border-[#245A40]/40 transition-colors">
              <div className="font-display text-4xl sm:text-5xl text-[#1B2A22] leading-none">{s.value}</div>
              <div className="mt-3 text-sm text-[#3F4A42]">{s.label}</div>
            </div>
          ))}
        </div>
      </section>

      {/* Ingredient pillars */}
      <section className="max-w-7xl mx-auto px-4 sm:px-6 py-16 sm:py-24 grid lg:grid-cols-12 gap-10">
        <div className="lg:col-span-5">
          <div className="text-xs uppercase tracking-[0.22em] text-[#245A40] font-semibold">Our ingredients</div>
          <h2 className="font-display text-4xl sm:text-5xl lg:text-[56px] mt-3 text-[#1B2A22] leading-[1.05]">
            Food that <em className="italic text-[#245A40]">heals</em>, not harms.
          </h2>
          <p className="mt-5 text-[#3F4A42] text-[17px] leading-relaxed max-w-md">
            We say no to seed oils, refined sugars and shortcuts. Every dish is built on anti-inflammatory foods — whole, organic ingredients finished with a sauce we made that morning.
          </p>
          <div className="mt-8 rounded-[24px] overflow-hidden border border-[#D6CFB8] hidden lg:block">
            <img src="/images/tiramisu.jpg" alt="House-made tiramisu — Wholesome 360 healthy catering desserts Chicago" className="w-full h-72 object-cover" />
          </div>
        </div>

        <div className="lg:col-span-7 grid sm:grid-cols-2 gap-3 sm:gap-4 self-start">
          {INGREDIENT_PILLARS.map((p, idx) => (
            <div key={p.title} className={`rounded-2xl p-6 sm:p-7 border ${idx % 2 === 0 ? 'bg-[#E6EBD5] border-[#CFDAB1]' : 'bg-[#FBF8EF] border-[#D6CFB8]'}`}>
              <div className={`w-11 h-11 rounded-full grid place-items-center ${idx % 2 === 0 ? 'bg-[#245A40] text-[#E6EBD5]' : 'bg-[#1B2A22] text-[#E8C56B]'}`}>
                <Leaf className="w-5 h-5" />
              </div>
              <div className="font-display text-2xl mt-5 text-[#1B2A22]">{p.title}</div>
              <div className="mt-2 text-[15px] text-[#3F4A42] leading-relaxed">{p.body}</div>
            </div>
          ))}
        </div>
      </section>
    </>
  );
}
